import type { NitroFetchRequest, $Fetch } from 'nitropack'
import type { FetchOptions } from 'ofetch'
import type { FullyPersonalizationOption } from '~/types/apis/v2/getFullyPersonalizationOption'
import type { GetPersonalizationDetailResponse } from '~/types/apis/v2/getPersonalizationDetail'

interface PersonalizationProduct {
  slug: string
  open_for_sale: number
  status: string
}

interface PersonalizationOption {
  data: {
    product_list: PersonalizationProduct[]
  }
  message: string
}
export const personalizationRepository = <T>(
  fetch: $Fetch<T, NitroFetchRequest>
) => ({
  async getFullPersonalizationOption(
    options: FetchOptions = {}
  ): Promise<PersonalizationOption> {
    return fetch<PersonalizationOption>(
      `/v2/storefront/product/full-personalization-option`,
      {
        ...options,
        method: 'GET'
      }
    )
  },
  async getFullPersonalizationDetail(
    product_slug?: string,
    options: FetchOptions = {}
  ): Promise<FullyPersonalizationOption> {
    return fetch<FullyPersonalizationOption>(
      `/v2/storefront/product/${product_slug}/full-personalization`,
      {
        ...options,
        method: 'GET'
      }
    )
  },
  async sharedLink(
    options: FetchOptions & { body?: unknown } = {}
  ): Promise<unknown> {
    return fetch<unknown>(
      '/v2/storefront/product/full-personalization/share-link',
      {
        ...options,
        method: 'POST'
      }
    )
  },
  async getSharedDetail(
    sharedKey: string,
    options: FetchOptions = {}
  ): Promise<GetPersonalizationDetailResponse> {
    return fetch<GetPersonalizationDetailResponse>(
      `/v2/storefront/product/full-personalization/share-link/${sharedKey}`,
      {
        ...options,
        method: 'GET'
      }
    )
  },

  async postFullPersonalizationGetList(payload: {
    product_slug_list: string[]
  }): Promise<PersonalizationOption> {
    return fetch<PersonalizationOption>(
      `/v2/storefront/product/full-personalization/get-list`,
      {
        method: 'POST',
        body: payload
      }
    )
  }
})
